import { ShimmeringLoaderBar } from '@kyruus/loaders-and-spinners';
import React, { ComponentProps } from 'react';

import { useImageService } from '@kyruus/image-component';
import { MarketableLocation } from 'Src/types';
import { getHeroImage } from 'Src/utils/location';
import { ImageLoadingContainer } from '../styles';
import { HeroImage } from './styles';

const DEFAULT_IMAGE = 'https://cdn.kyruus.com/img/location-hero-default.jpg';

enum HeroImageDimensions {
  width = 1000,
  height = 494
}

interface BaseImageProps {
  loading: boolean;
  marketableLocation?: MarketableLocation;
}

type ImageProps = BaseImageProps & ComponentProps<'div'>;

export const Image = ({
  loading,
  marketableLocation,
  ...props
}: ImageProps) => {
  const { getImageUrl, config } = useImageService();

  if (loading) {
    return (
      <ImageLoadingContainer
        data-testid="Loading"
        role="presentation"
        {...props}
      >
        <ShimmeringLoaderBar />
      </ImageLoadingContainer>
    );
  }

  if (!marketableLocation) {
    return null;
  }

  let imgSrc = getHeroImage(marketableLocation.media) || DEFAULT_IMAGE;

  if (getImageUrl && config.enableEnhancement) {
    imgSrc = getImageUrl(imgSrc, {
      width: HeroImageDimensions.width,
      height: HeroImageDimensions.height
    });
  }

  return (
    <div data-testid="ImageContainer" {...props}>
      <HeroImage
        data-testid="HeroImage"
        imageUrl={imgSrc}
        enhancementEnabled={config.enableEnhancement}
      />
    </div>
  );
};
